import IPostMessage from '../../IPostMessage';
import ITimingTriggersMessage from './ITimingTriggersMessage';

export default class Triggers {
	public static MESSAGE_PREFIX: string = 'triggers';

	/** @internal */
	constructor(
		private messagePrefix: string,
		private postMessage: IPostMessage<ITimingTriggersMessage>,
	) {}

	/**
	 * @internal
	 * @todo
	 */
	public async pause() {
		await this.postMessage({ type: this.getMessage('pause') });
	}

	/**
	 * @internal
	 * @todo
	 */
	public async resume() {
		await this.postMessage({ type: this.getMessage('resume') });
	}

	private getMessage(name: string) {
		return this.messagePrefix + '.' + Triggers.MESSAGE_PREFIX + '.' + name;
	}
}
